import { render, staticRenderFns } from "./ArticleGroup.vue?vue&type=template&id=6c8aa76d&scoped=true&"
import script from "./ArticleGroup.vue?vue&type=script&lang=js&"
export * from "./ArticleGroup.vue?vue&type=script&lang=js&"
import style0 from "./ArticleGroup.vue?vue&type=style&index=0&id=6c8aa76d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8aa76d",
  null
  
)

export default component.exports